export default "__VITE_ASSET__B4iPp8bx__"